import React from 'react';

interface SectionHeaderProps {
  children: React.ReactNode;
  className?: string;
}

const SectionHeader = ({ children, className = '' }: SectionHeaderProps) => {
  return (
    <div
      className={`flex items-center px-4 pb-2 mb-1 [&>svg]:mr-2 ${className}`}
      data-testid="section-header"
    >
      {children}
    </div>
  );
};

export default SectionHeader;
